<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <fh-ellipsis :content="getFieldValue" />
</template>

<script setup>
import { computed } from 'vue';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';

import useShowFields from '@/hooks/field-show';
const { handleDataProcessing } = useShowFields();

const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  }
});

// 提取字段信息
const fieldsInfo = computed(() => props.params);
// 获取字段值
const getFieldValue = computed(() => {
  // 处理数据
  return handleDataProcessing(fieldsInfo.value);
});
</script>
<style scoped lang="less">
@import './date.less';
</style>
